import NoData from '@/components/common/NoData'
import { useAuthContext } from '@/features/auth/context'
import { SearchParams } from '@/types/common'
import { CircularProgress } from '@mui/material'
import { Stack } from '@mui/system'
import { useEffect, useState } from 'react'
import { ConfigLayout } from '../../components/common'
import ConfigHeader from '../../components/common/Header'
import { useConfigUI } from '../../context'
import useSearchSiteLocation from '../../hooks/sitesandlocations/useSearchSiteAndLocation'
import SitesAndLocationTable from './SitesAndLocationTable'
import useTranslation from '@/hooks/useTranslation'

function SitesAndLocations() {
  const { t } = useTranslation()
  
  const { openSidebar, setSidebarView } = useConfigUI()
  const { interfaceId } = useAuthContext()
  const handleEditLocation = (id: string, name: string, siteId: string) => {
    openSidebar()
    setSidebarView({ type: 'LOCATION_VIEW', id, name, siteId })
  }
  const handleEditSite = (id: string, name: string) => {
    openSidebar()
    setSidebarView({ type: 'SITE_VIEW', id, name })
  }

  const [searchParams, setSearchParams] = useState<SearchParams>({
    interfaceId: Number(interfaceId),
  })

  useEffect(() => {
    setSearchParams({ interfaceId: Number(interfaceId) })
  }, [interfaceId])

  const { data } = useSearchSiteLocation(searchParams)

  // const handleSearch = debounce((event: SelectChangeEvent) => {
  //   const value = `${event.target.value}`
  //   setSearchParams({
  //     interfaceId: interfaceId,
  //     Keyword: value,
  //   })
  // }, 500)

  return (
    <ConfigLayout
      title="Sites And Locations"
      header={<ConfigHeader subtitle="Data Config" title="Sites & Locations" />}
      fullWidth
    >
      {/* <Stack sx={{ margin: '13px 15px', height: '32px' }}>
        <SearchInput name="Search Site & Locations" onChange={handleSearch} />
      </Stack> */}

      {!data && (
        <Stack
          sx={{
            position: 'absolute',
            transform: 'translate(-50%, -50%)',
            left: '50%',
            top: '35%',
          }}
        >
          <CircularProgress />
        </Stack>
      )}

      <Stack sx={{ padding: '0px 15px', mt: '20px' }} flexGrow="1">
        {data && data.list.length > 0 && (
          <SitesAndLocationTable
            rows={data.list}
            onEditSiteItem={handleEditSite}
            onEditLocationItem={handleEditLocation}
          />
        )}
      </Stack>

      {data && data.totalCount === 0 && <NoData text={ t('noData') } />}
    </ConfigLayout>
  )
}

export default SitesAndLocations
